'use client';

import { useTranslations } from 'next-intl';
import React, { FC, memo, useEffect } from 'react';

import { Avatar } from '@/.gql/graphql';
import { AvatarItem } from '@/src/components/AvatarItem';
import { useStyleContext } from '@/src/providers';

const styles = {
  chooseTitle: 'text-base font-bold mb-3',
  options: 'flex gap-y-2 gap-x-4 flex-wrap',
  noAvatar: 'font-medium text-label-secondary text-sm',
};

export interface TAvatarsProps {
  avatars: Avatar[];
}

export const AvatarsComponent: FC<TAvatarsProps> = ({ avatars }) => {
  const t = useTranslations('imageModal');
  const { setIsYourPhoto } = useStyleContext();

  useEffect(() => {
    setIsYourPhoto(false);
  }, [setIsYourPhoto]);

  return (
    <div>
      <div className={styles.chooseTitle}>
        {avatars?.length ? t('chooseTitle') : t('noAvatarTitle')}
      </div>

      <div className={styles.options}>
        {avatars?.length ? (
          avatars.map((avatar) => (
            <AvatarItem key={avatar.id} avatar={avatar} />
          ))
        ) : (
          <div className={styles.noAvatar}>{t('noAvatarText')}</div>
        )}
      </div>
    </div>
  );
};

export const Avatars = memo(AvatarsComponent);
